export default (hostname = window.location.hostname): boolean =>
  hostname.startsWith('local.');
